import styled from 'styled-components'

export const Wrapper = styled.div`
    position: absolute;
    bottom: 0;
    right: 0;
    max-width: 254px;
    display: none;

    &.slideUp {
        transition: opacity 1s ease-in-out, transform 1s ease-in-out;
        opacity: 0;
        transform: translateY(100%);
    }

    &.slideUp.enter {
        transition: opacity 1s ease-in-out 0.3s, transform 1s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.3s;
        opacity: 1;
        transform: translateY(0);
    }

    @media (print), (prefers-reduced-motion: reduce) {
        &.slideUp {
            transition: none;
            opacity: 1;
            transform: none;
        }
    }

    body.no-js & {
        opacity: 1;
        transform: none;
    }

    @media ${(props) => props.theme.query.desktop} {
        display: block;
    }
`
